// extracted by mini-css-extract-plugin
module.exports = {"item-text":"faq_item-text__2AmtT","underline":"faq_underline__2BMRT","hover-opacity":"faq_hover-opacity__30gXG"};